import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { ILessonPlanResponse } from '../../../../apis/academics/academicsLessonPlans.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsLessonPlansKey = 'get-academics-lesson-plans';

export type TAcademicsLessonPlansParams = {
  page?: number;
  limit?: number;
  academicYear?: string;
  grade?: string;
};

export const useAcademicsLessonPlansHook = (
  params: TAcademicsLessonPlansParams,
  options?: UseQueryOptions<ILessonPlanResponse, TQueryError>
): UseQueryResult<ILessonPlanResponse, TQueryError> => {
  const { getAcademicsLessonPlans } = useAcademicsService();

  return useQuery<ILessonPlanResponse, TQueryError>({
    queryKey: [getAcademicsLessonPlansKey, params],
    queryFn: () => getAcademicsLessonPlans(params),
    enabled: true,
    ...options,
  });
};
